import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import AuthService from './auth';

const AdminProtectedRoute = ({ children }) => {
    const { currentAdmin, loading } = useAuth();
    const isAdminAuthenticated = AuthService.isAuthenticated();

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!currentAdmin) {
        return <Navigate to="/admin/login" replace />;
    }

    return children;
};

export default AdminProtectedRoute;